import { PROCESS_INCOMING_MESSAGE } from './actionTypes'

export const incomingMessage = (stateLocation, message, allowedMultipleWhitelist) => {
    return {
        type: PROCESS_INCOMING_MESSAGE,
        payload: {
            message: message,
            allowedMultipleWhitelist,
            stateLocation
        }

    }
};


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/clientcommunicator/src/actions/actions.js